import type { FeedingPen } from './penTypes';
import type { FeedingPenQuality } from './summaryTypes';

/** The Bioscope state a pen is counted under in `FeedingPenQuality`. */
export type PenQualityState = keyof FeedingPenQuality;

type PenQualityInput = Pick<FeedingPen, 'bioscopeDataQuality' | 'bioscopeInPeriod'>;

/**
 * The state this pen is counted under, by the same rule as the API's `summary.penQuality`.
 *
 * A pen without data that had no Bioscope in the period is `noBioscope` rather than
 * `noData`: nothing is missing there, it had nothing to measure it with. One rule for the
 * counts and for the notice that names the pens, so the named pens always add up to them.
 */
export function penQualityState(pen: PenQualityInput): PenQualityState {
    if (pen.bioscopeDataQuality === 'noData' && !pen.bioscopeInPeriod) return 'noBioscope';
    return pen.bioscopeDataQuality;
}

/** Counts from the pens alone, which carry their own state in either API version. */
export function penQualityFromPens(pens: readonly PenQualityInput[]): FeedingPenQuality {
    const counts: FeedingPenQuality = { ready: 0, collecting: 0, noData: 0, noBioscope: 0 };
    for (const pen of pens) counts[penQualityState(pen)] += 1;
    return counts;
}
